import React, { useState } from "react";

interface InputBarProps {
  onSend: (inputText: string) => void;
}

const InputBar: React.FC<InputBarProps> = ({ onSend }) => {
  const [input, setInput] = useState("");

  const handleSend = () => {
    if (input.trim() !== "") {
      onSend(input);
      setInput("");
    }
  };

  return (
    <div className="flex items-center gap-3">
      <input
        type="text"
        value={input}
        onChange={(e) => setInput(e.target.value)}
        className="flex-1 px-4 py-2 rounded-xl border border-darkgray bg-secondary text-offwhite focus:outline-none focus:ring-2 focus:ring-teal/30 text-sm transition"
        placeholder="Type a message..."
      />
      <button
        onClick={handleSend}
        className="px-4 py-2 bg-teal text-offwhite text-sm rounded-xl hover:bg-teal/80 transition-all"
      >
        Send
      </button>
    </div>
  );
};

export default InputBar;
